import { ConciergeTypes } from "@/enums/ConciergeTypes";
import { ServiceStatus } from "@/enums/ServiceStatus";
import { PremiumServiceEventTypes } from "@/enums/PremiumServiceEventTypes";
import Loader from "@/components/loader/Loader.vue";
import moment from "moment/moment";

export default {
  name: "ConciergeList",
  components: {
    Loader
  },
  data() {
    return {
      loading: true,
      categories: [],
      currentDate: moment(new Date()).toDate(),
      headers: [
        {
          sortable: false,
          value: 'icon',
          width: 30
        },
        {
          text: this.$i18n.messages[this.$i18n.locale]['GeneralTranslations.Type'],
          sortable: true,
          value: 'type',
          align: "center",
        },
        {
          text: this.$i18n.messages[this.$i18n.locale]['Concierge.NumberOfDimensions'],
          sortable: true,
          value: 'numberCategories',
          align: "center",
        },
        {
          text: this.$i18n.messages[this.$i18n.locale]['Concierge.Amount'],
          sortable: true,
          value: 'amount',
          align: "center",
        },
        {
          text: this.$i18n.messages[this.$i18n.locale]['Concierge.PendingBookings/Orders'],
          sortable: true,
          value: 'pending',
          align: "center",
        },
      ],
      conciergeData: []
    }
  },
  computed: {
    conciergeTypes() {
      return ConciergeTypes;
    },
    serviceStatus() {
      return ServiceStatus;
    },
    premiumServiceEventTypes() {
      return PremiumServiceEventTypes;
    },
    additionalServices() {
      return this.$store.state.additionalServicesModule.additionalServices;
    },
    additionalServiceCategories() {
      return this.$store.state.additionalServicesModule.additionalServiceCategories[0];
    },
    serviceRequestsAwaiting() {
      return this.$store.state.additionalServicesModule.serviceRequestsDashboard;
    },
    requestsAdditionalServices() {
      return this.additionalServices.filter(x => [
        this.premiumServiceEventTypes.ByAppointment,
        this.premiumServiceEventTypes.AppAccess,
        this.premiumServiceEventTypes.Request,
      ].includes(x.type));
    },
    eventsAdditionalServices() {
      return this.additionalServices
        .filter(x => [
          this.premiumServiceEventTypes.EventBased,
          this.premiumServiceEventTypes.ConciergeEvent,
          this.premiumServiceEventTypes.Event,
        ].includes(x.type));
        //.filter(service => moment(service?.start?.seconds * 1000).toDate() >= this.currentDate || !service?.hasOwnProperty('start'))
    },
    productsAdditionalServices() {
      return this.additionalServices.filter(x => [
        this.premiumServiceEventTypes.Gift,
        this.premiumServiceEventTypes.Product,
      ].includes(x.type));
    },
  },
  async mounted() {
    Promise.all([
      this.$store.dispatch("getAdditionalServiceCategories"),
      await this.$store.dispatch("getAwaitingApprovalRequests"),
      this.$store.dispatch("getAdditionalServices"),
    ]).then(() => {
      this.getConciergeTable();
      this.loading = false;
    });
  },
  methods: {
    async getConciergeTable() {
      const types = Object.values(this.conciergeTypes);

      for(let i = 0; i < types.length; i++) {
        const type = types[i];

        this.conciergeData.push({
          icon: this.getIcon(type),
          type: type,
          numberCategories: this.getNumberCategory(type),
          amount: this.getAmount(type),
          pending: this.getPending(type),
        });
      }
    },
    getNumberCategory(type: string) {
      const categories = [];

      const processServices = (services) => {
        services.forEach((service) => {
          if (!categories.includes(service.category)) {
            categories.push(service.category);
          }
        });
      };

      switch (type) {
        case this.conciergeTypes.Requests:
          processServices(this.requestsAdditionalServices);
          break;
        case this.conciergeTypes.Events:
          processServices(this.eventsAdditionalServices);
          break;
        case this.conciergeTypes.Products:
          processServices(this.productsAdditionalServices);
          break;
      }

      return categories.length;
    },
    getAmount(type: string) {
      switch (type) {
        case this.conciergeTypes.Requests:
          return this.requestsAdditionalServices.length;
        case this.conciergeTypes.Events:
          return this.eventsAdditionalServices.length;
        case this.conciergeTypes.Products:
          return this.productsAdditionalServices.length;
      }
    },
    getPending(type: string) {
      switch (type) {
        case this.conciergeTypes.Requests:
          return this.serviceRequestsAwaiting.filter(x => this.requestsAdditionalServices.find(y => y.id === x.serviceId)).length;
        case this.conciergeTypes.Events:
          return this.serviceRequestsAwaiting.filter(x => this.eventsAdditionalServices.find(y => y.id === x.serviceId)).length;
        case this.conciergeTypes.Products:
          return this.serviceRequestsAwaiting.filter(x => this.productsAdditionalServices.find(y => y.id === x.serviceId)).length;
      }
    },
    openPage(item) {
      switch (item.type) {
        case this.conciergeTypes.Events:
          this.$router.push("/concierge-events");
          return;
        case this.conciergeTypes.Products:
          this.$router.push("/concierge-products");
          return;
        case this.conciergeTypes.Requests:
          this.$router.push("/concierge-requests");
          return;
      }
    },
    getIcon(type: string) {
      switch (type) {
        case this.conciergeTypes.Events:
          return 'mdi-calendar-outline';
        case this.conciergeTypes.Products:
          return 'mdi-basket';
        case this.conciergeTypes.Requests:
          return 'mdi-room-service';
      }
    },
  }
}
